var React = require('react');

function Star18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.00006 0L11.3806 5.72348L17.5596 6.21885L12.8518 10.2515L14.2901 16.2812L9.00006 13.05L3.70999 16.2812L5.14828 10.2515L0.440552 6.21885L6.61953 5.72348L9.00006 0Z","fill":"currentColor"}));
}

Star18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Star18;

Star18.default = Star18;
